<template>
  <i class="icon-arrow-right"></i>
</template>

<script>
export default {
  name: "BackArrow",
};
</script>

<style scoped>
[class*="icon"] {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  color: #bf1311;
  box-sizing: border-box;
}

[class*="icon"]:after,
[class*="icon"]:before {
  content: "";
  box-sizing: border-box;
}

[class*="icon-arrow"] {
  width: 15px;
  height: 15px;
  border-width: 2px 2px 0 0;
  border-style: solid;
  margin: 10px;
}

[class*="icon-arrow"]:before {
  right: 0;
  top: -2px;
  position: absolute;
  height: 3px;
  box-shadow: inset 0 0 0 32px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  width: 18px;
  -webkit-transform-origin: right top;
  transform-origin: right top;
}

[class*="icon-arrow"][class*="-right"] {
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}

[class*="icon"] {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  color: #bf1311;
  box-sizing: border-box;
}

[class*="icon"]:after,
[class*="icon"]:before {
  content: "";
  box-sizing: border-box;
}
</style>
